import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AccessControlService } from 'src/app/services/access-control.service';

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.css']
})
export class EmailVerificationComponent implements OnInit {
  isEmailVerificationEnabled: Boolean;
  toggleButtonStatus: Boolean;
  constructor(private readonly accessControlService: AccessControlService,
    private readonly toastr: ToastrService
  ) { }

  ngOnInit() {
    this.getEmailVerificationStatus()
  }

  enableEmailVerification() {
    let user_id = localStorage.getItem('user_id')
    this.isEmailVerificationEnabled = !this.isEmailVerificationEnabled
    this.accessControlService.enableEmailVerification(user_id, this.isEmailVerificationEnabled).subscribe(((res: any) => {
      if (this.isEmailVerificationEnabled)
       { this.toastr.success(`Enabled Email Verification `) }
      else {
        this.toastr.warning(`Disabled Email Verification `)
      }

    }),
      (err => {
        console.log(err)
        this.toastr.error(`${err.message} `)
      }),
      () => {

      }
    )
  }

  getEmailVerificationStatus() {
    let user_id = localStorage.getItem('user_id')
    this.accessControlService.emailVerificationStatus(user_id).subscribe((res: any) => {
      this.isEmailVerificationEnabled = res.EmailVerificationStatus
      this.toggleButtonStatus = this.isEmailVerificationEnabled
    })
      , (err) => {
        this.toastr.error(`${err.message}`)
      }
  }
}
